import type { IconProps } from '../icon'

import { useStyleConfig, vui } from '../core'
import Icon from '../icon'
import { cs } from '../utils'
import { useTextFieldContext } from './context'

/** Displays an icon within the TextField. */
export const TextFieldIcon = vui<'svg', IconProps>((props, ref) => {
  const { className, ...rest } = props
  const fieldProps = useTextFieldContext()
  const mergedProps = { ...fieldProps, ...props }
  const styles = useStyleConfig('Input', mergedProps)

  return <Icon className={cs('vui-textFieldIcon', className)} ref={ref} {...styles.icon} {...rest} />
})

TextFieldIcon.displayName = 'TextFieldIcon'

export default TextFieldIcon
